// extracted by mini-css-extract-plugin
export var cardIcon = "_8v-4";
export var checkboxCard = "_8v-0";
export var checkboxCardSelected = "_8v-3";
export var disabled = "_8v-1";
export var outerBorder = "_8v-2";
export var spacerMedium = "_8v-7";
export var spacerSmall = "_8v-6";
export var spacerXsmall = "_8v-5";